module.exports = __webpack_public_path__ + "img/IPP.f09114a3.png";